import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Paper,
  FormControlLabel,
  Checkbox,
  makeStyles,
} from "@material-ui/core";
import t from "../common/localization";
import {
  formatDistance,
  formatHours,
  formatDate,
  formatSpeed,
  formatVolume,
  formatDurationTime,
} from "../common/formatter";
import ReportFilter from "./ReportFilter";
import ReportLayoutPage from "./ReportLayoutPage";
import { useAttributePreference } from "../common/preferences";
import { showLoaderStateActions } from "./../store";
import { useDispatch, useSelector } from "react-redux";
import Chip from "@material-ui/core/Chip";
import AcUnitIcon from "@material-ui/icons/AcUnit";
import LocalGasStationIcon from "@material-ui/icons/LocalGasStation";
import NavigationIcon from "@material-ui/icons/Navigation";
import SpeedIcon from "@material-ui/icons/Speed";
import { DataGrid } from '@material-ui/data-grid';
import formatTimeDuration from "../CommonFunctions/commonFormatter";


const useStyles = makeStyles((theme) => ({
  tableRow: {
    "&$hover:hover": {
      backgroundColor: "#FFFFFF",
    },
  },
  checkbox: {
    marginBottom: "10px",
  },
  tCell: {
    color: "white",
    backgroundColor: "#361DDB",
  },
  tContainer: {
    maxHeight: 690,
  },
}));

const Filter = ({ setItems }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [daily, setDaily] = useState(false);

  const handleSubmit = async (
    deviceId,
    groupId,
    from,
    to,
    mail,
    headers,
    onResponseGet
  ) => {
    const timeSlot = daily ? "day" : null;
    const query = new URLSearchParams({ from, to, timeSlot, mail });

    let qString = query.toString();
    let deviceIdQuery = "";
    let groupIdQuery = "";

    deviceId.forEach((element) => {
      deviceIdQuery += `&deviceId=${element}`;
    });
    groupId.forEach((element) => {
      groupIdQuery += `&groupId=${element}`;
    });

    if (deviceIdQuery) {
      qString += deviceIdQuery;
    }
    if (groupIdQuery) {
      qString += groupIdQuery;
    }
    dispatch(showLoaderStateActions.addState(true));
    const response = await fetch(`/api/reports/offlineDuration?${qString}`, {
      headers,
    });
    onResponseGet(response);
    if (response.ok && response.headers.get("content-type")) {
      const contentType = response.headers.get("content-type");
      if (contentType === "application/pdf") {
        const name = "report.pdf";
        const blobUrl = URL.createObjectURL(await response.blob());
        // Create a link element
        const link = document.createElement("a");
        // Set link's href to point to the Blob URL
        link.href = blobUrl;
        link.download = name;
        // Append link to the body
        document.body.appendChild(link);
        // Dispatch click event on the link
        // This is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        // Remove link from body
        document.body.removeChild(link);
        dispatch(showLoaderStateActions.addState(false));
      } else if (contentType === "application/json") {
        const resItem = await response.json();
        dispatch(showLoaderStateActions.addState(false));
        setItems(resItem);
      } else {
        dispatch(showLoaderStateActions.addState(false));
        window.location.assign(
          window.URL.createObjectURL(await response.blob())
        );
      }
    } else {
      dispatch(showLoaderStateActions.addState(false));
    }
  };

  return (
    <ReportFilter handleSubmit={handleSubmit} reportHeader="Offline Duration">
      <FormControlLabel
        className={classes.checkbox}
        control={
          <Checkbox
            color="primary"
            checked={daily}
            onChange={(e) => setDaily(e.target.checked)}
          />
        }
        label={"Daily Offline"}
      />
    </ReportFilter>
  );
};

const columns = [
  {field: "deviceName", headerName: t("settingsVehicleNumber"), flex: 1},
  {field: "reportStartDate", headerName: t("reportStartDate"), flex: 1},
  {field: "offlineDuration", headerName: "Offline duration", flex: 1},
  {field: "reportEndDate", headerName: t("reportEndDate"), flex: 1},
]

const OfflineReportPage = () => {
  const distanceUnit = useAttributePreference("distanceUnit");
  const speedUnit = useAttributePreference("speedUnit");
  const [items, setItems] = useState([]);
  const classes = useStyles();

  let mainData = [];
  const setRecursiveData = (newItems) => {
    setTimeout(() => {
      let hasMore = mainData.length + 1 < newItems.length;
      const list = newItems.slice(0, mainData.length + 1);
      mainData = list;
      setItems(list);
      if (hasMore) setRecursiveData(newItems);
    }, 0);
  };

  const setData = (newItems) => {
    mainData = [];
    setRecursiveData(newItems);
  };

  const gridRows = items.map((item, index) => ({
    id: index,
    deviceName: item.deviceName,
    reportStartDate: formatDate(item.startTime, "MMM D, hh:mm A"),
    reportEndDate: formatDate(item.endTime, "MMM D, hh:mm A"),
    offlineDuration: formatTimeDuration(item.offlineDuration),
  }))

  return (
    <ReportLayoutPage filter={<Filter setItems={setData} />}>
      <DataGrid
        autoHeight
        pagination
        disableSelectionOnClick
        style={{ height: "85vh", width: "100%", backgroundColor: "white" }}
        columns={columns}
        rows={gridRows}
      />


      {/* <TableContainer className={classes.tContainer} component={Paper}>
        <Table
          stickyHeader
          aria-label="sticky table"
          style={{ whiteSpace: "nowrap" }}
        >
          <TableHead style={{ backgroundColor: "#361DDB" }}>
            <TableRow>
              <TableCell className={classes.tCell}>
                {t("settingsVehicleNumber")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportStartDate")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportEndDate")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportStartOdometer")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportEndOdometer")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("sharedDistance")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportAverageSpeed")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportMaximumSpeed")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportEngineHours")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("reportACHours")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("runningTime")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("stoppedTime")}
              </TableCell>
              <TableCell className={classes.tCell}>{t("idleTime")}</TableCell>
              <TableCell className={classes.tCell}>
                {t("reportSpentFuel")}
              </TableCell>
              <TableCell className={classes.tCell}>
                {t("mileageFuel")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <TableRow hover key={item.id} className={classes.tableRow}>
                <TableCell width="120px">{<b>{item.deviceName}</b>}</TableCell>
                <TableCell>
                  {formatDate(item.startTime, "MMM D, hh:mm A")}
                </TableCell>
                <TableCell>
                  {formatDate(item.endTime, "MMM D, hh:mm A")}
                </TableCell>
                <TableCell>
                  {formatDistance(item.startOdometer, distanceUnit)}
                </TableCell>
                <TableCell>
                  {formatDistance(item.endOdometer, distanceUnit)}
                </TableCell>
                <TableCell>
                  <Chip
                    label={formatDistance(item.distance, distanceUnit)}
                    icon={<NavigationIcon />}
                    size="small"
                    color="secondary"
                    style={{
                      backgroundColor: "#D8ECDB",
                      color: "#29A639",
                      borderRadius: 3,
                      margin: "5px",
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Chip
                    label={formatSpeed(item.averageSpeed, speedUnit)}
                    icon={<SpeedIcon />}
                    size="small"
                    color="secondary"
                    style={{
                      backgroundColor: "#D8ECDB",
                      color: "#29A639",
                      borderRadius: 3,
                      margin: "5px",
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Chip
                    label={formatSpeed(item.maxSpeed, speedUnit)}
                    icon={<SpeedIcon />}
                    size="small"
                    color="secondary"
                    style={{
                      backgroundColor: "#D8ECDB",
                      color: "#29A639",
                      borderRadius: 3,
                      margin: "5px",
                    }}
                  />
                </TableCell>
                <TableCell>{formatDurationTime(item.engineHours)}</TableCell>
                <TableCell>
                  <Chip
                    label={formatDurationTime(item.airConditionerHours)}
                    icon={<AcUnitIcon />}
                    size="small"
                    color="secondary"
                    style={{
                      backgroundColor: "#D6F2FF",
                      color: "#00B2FC",
                      borderRadius: 3,
                      margin: "5px",
                    }}
                  />
                </TableCell>
                <TableCell>{formatDurationTime(item.runningHours)}</TableCell>
                <TableCell>{formatDurationTime(item.stoppedHours)}</TableCell>
                <TableCell>{formatDurationTime(item.idleHours)}</TableCell>
                <TableCell>
                  <Chip
                    label={formatVolume(item.spentFuel)}
                    icon={<LocalGasStationIcon />}
                    size="small"
                    color="secondary"
                    style={{
                      backgroundColor: "#FFE9D1",
                      color: "#FCAF25",
                      borderRadius: 3,
                      margin: "5px",
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Chip
                    label={formatVolume(item.mileageFuelConsumed)}
                    icon={<LocalGasStationIcon />}
                    size="small"
                    color="secondary"
                    style={{
                      backgroundColor: "#D8ECDB",
                      color: "#29A639",
                      borderRadius: 3,
                      margin: "5px",
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer> */}
    </ReportLayoutPage>
  );
};

export default OfflineReportPage;
